import regeneratorRuntime from "/app/node_modules/.pnpm/next@12.1.0_9e28c9c572526b9bcff5de1d3b30ce0c/node_modules/next/dist/compiled/regenerator-runtime/runtime.js";
import axios from 'axios';
import Cookies from 'js-cookie';
import getCsrfCode from '../utils/getCsrfCode';
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
export var isLogin = function() {
    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(redirect) {
        var ref, uin, skey, csrfcode, ref1, data, code, logined;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!QCLogin.isLogin()) {
                        _ctx.next = 13;
                        break;
                    }
                    ;
                    uin = parseInt(String(Cookies.get('uin') || '').replace(/^o0*/, ''), 10);
                    skey = Cookies.get('skey') || '';
                    csrfcode = getCsrfCode(skey);
                    _ctx.next = 7;
                    return axios.get("/main/ajax/user/getMenuAccountInfo?uin=".concat(uin, "&csrfCode=").concat(csrfcode), {
                        withCredentials: true
                    }).then(function(res) {
                        return res.data;
                    });
                case 7:
                    ref1 = _ctx.sent;
                    data = ref1.data;
                    code = ref1.code;
                    logined = !code && (data === null || data === void 0 ? void 0 : (ref = data.userInfo) === null || ref === void 0 ? void 0 : ref.isLogined);
                    if (!logined) {
                        _ctx.next = 13;
                        break;
                    }
                    return _ctx.abrupt("return", true);
                case 13:
                    if (redirect) {
                        location.href = "".concat(location.origin, "/login?s_url=").concat(encodeURIComponent(location.href));
                    }
                    return _ctx.abrupt("return", false);
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function isLogin(redirect) {
        return _ref.apply(this, arguments);
    };
}();
